import React from 'react';
import { Chip } from '@mui/material';

const STATUS_COLORS: Record<
  string,
  'info' | 'primary' | 'warning' | 'success' | 'default'
> = {
  open: 'info',
  pending: 'warning',
  waiting_on_customer: 'warning',
  resolved: 'success',
  closed: 'default',
};

const PRIORITY_COLORS: Record<
  string,
  'default' | 'info' | 'warning' | 'error'
> = {
  low: 'default',
  medium: 'info',
  high: 'warning',
  critical: 'error',
};

function titleCase(s: string): string {
  return s.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

interface CaseStatusChipProps {
  value: string;
  type: 'status' | 'priority';
}

const CaseStatusChip: React.FC<CaseStatusChipProps> = ({ value, type }) => {
  const color =
    type === 'status'
      ? STATUS_COLORS[value] || 'default'
      : PRIORITY_COLORS[value] || 'default';

  return (
    <Chip
      label={titleCase(value)}
      size="small"
      color={color}
      variant="outlined"
    />
  );
};

export default CaseStatusChip;
